import styled from 'styled-components';


export const DashboardContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${props => props.theme.white1};
  height: 100vh;
`;
export const ContentContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: auto;
  margin-left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const DownloadButton = styled.button`

  margin-top: 40px;
  padding: 10px 25px 10px 25px;
  box-sizing: border-box;
  border: 0;
  background-color: ${(props) => props.theme.colorwhite0};
  border-radius: 30px;
  font-size: 18px;
  font-weight: 700;
  outline: none;
  color: ${(props) => props.theme.black1};
  text-align: center;
  &:hover {
    cursor: pointer;

    background-color: ${(props) => props.theme.white5};
  }
`;
